/* eslint-disable */
// const state = {
//   variant : null,
//   oilMaker : null,
//   bottleMaker : null,
//   labelMaker : null,
//   month : null,
//   year : null,
// }
const state = {
  pic : null,
  dealer : null,
  status : null
}

const getters = {
  //variant
  // getVariant : (state) => {
  //   return state.variant
  // },

  //Sample for multiple
  // getSparepart : (state) => (brand_id, sparepart_type) => {
  //   if(
  //     (brand_id == null || (typeof brand_id != 'string' && brand_id.length == 0)) &&
  //     (sparepart_type == null || (typeof sparepart_type != 'string' && sparepart_type.length == 0))
  //   ) return state.sparepart

  //   var brand_ids = []
  //   var sparepart_types = []
  //   var compiledStr = ""

  //   //Array of 'brand_id' strings or a string of 'brand_id'
  //   if (brand_id != null && (typeof brand_id == 'number' || brand_id.length > 0)){
  //     brand_ids = typeof brand_id == 'number' ? [brand_id] : brand_id
  //     compiledStr += "brand_ids.indexOf(singleSparepart.sparepart_brand_id) !== -1 &&"
  //   }

  //   //Array of 'sparepart_type' strings or a string of 'sparepart_type'
  //   if(sparepart_type != null && (typeof sparepart_type == 'string' || sparepart_type.length > 0)){
  //     sparepart_types = typeof sparepart_type == 'string' ? [sparepart_type] : sparepart_type
  //     compiledStr += "sparepart_types.indexOf(singleSparepart.sparepart_variants.sparepart_type.name) !== -1 &&"
  //   }

  //   if(compiledStr != "") compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";
  //   compiledStr = "state.sparepart.filter((singleSparepart) => { return " + compiledStr;

  //   return eval(compiledStr)
  // },
  getFilterOptions : (state) => {
    const filterOptions = Object.assign({} , state)
    return filterOptions
  },
  getDealer : (state) => (search) => {
    // let dealerList = state
    if(search){
      let data = state.dealer.filter(x => x.showName.includes(search))
      return data
    } 
    else
      return state.dealer;
  },
  getStatus : (state) => {
      const status = Object.assign({} , state.status)
      return status;
  }
}

const mutations = {
  picStatus (state, pic) {
    if(pic){
      state.pic = pic;
    } else {
      delete state.pic
    }
  },
  dealerStatus (state , dealer) {
    if(dealer){
      state.dealer = dealer;
    } else {
      delete state.dealer
    }
  },
  statusStatus (state , status) {
    if(status){
      state.status = status;
    } else {
      delete state.status
    }
  },

  // oilMakerStatus (state, oilMaker) {
  //   if(oilMaker){
  //     state.oilMaker = oilMaker;
  //   } else {
  //     delete state.oilMaker
  //   }
  // },
  // bottleMakerStatus (state, bottleMaker) {
  //   if(bottleMaker){
  //     state.bottleMaker = bottleMaker;
  //   } else {
  //     delete state.bottleMaker
  //   }
  // },
  // labelMakerStatus (state, labelMaker) {
  //   if(labelMaker){
  //     state.labelMaker = labelMaker;
  //   } else {
  //     delete state.labelMaker
  //   }
  // },
  // monthStatus (state, month){
  //     if(month){
  //       state.month = month;
  //     } else {
  //       delete state.month
  //     }
  // },
  // yearStatus (state, year) {
  //   if(year){
  //     state.year = year;
  //   } else {
  //     delete state.year
  //   }
  // },
  filterOptionsStatus (state, filterOptions){
    if(filterOptions){
      for (var i in state) state[i] = filterOptions[i] != null ? filterOptions[i] : null;
    } else {
      for (var i in state) delete state[i]
    }
  }
}

const actions = {
  // setVariant ({ commit }, variant){
  //   commit('variantStatus', variant);
  // },
  // setOilMaker ({ commit }, oilMaker){
  //   commit('oilMakerStatus', oilMaker);
  // },
  // setBottleMaker ({ commit }, bottleMaker){
  //   commit('bottleMakerStatus', bottleMaker);
  // },
  // setLabelMaker ({ commit }, labelMaker){
  //   commit('labelMakerStatus', labelMaker);
  // },
  // setMonth ({ commit }, month){
  //   commit('monthStatus', month);
  // },
  // setYear ({ commit }, year){
  //   commit('yearStatus', year);
  // },
  // setFilterOptions ({ commit }, filterOptions){
  //   commit('filterOptionsStatus', filterOptions);
  // },

  setPic ({ commit } , pic) {
    commit('picStatus' , pic)
  },
  setDealer ({ commit } , dealer) {
    commit('dealerStatus' , dealer)
  },
  setStatus ({ commit } , status) {
    commit('statusStatus' , status)
  },
}

export default{
  state,
  getters,
  mutations,
  actions
}